import React from 'react';
import PropTypes from 'prop-types';
import FormatUtils from 'utils/format';
import SHUtils from 'utils/sh-utils';
import StarRating from './StarRating';

const StarRatingWithCategory = ({numberOfReviews, starRating}) => {
    if (numberOfReviews < 10) {
        return null;
    }

    const category = SHUtils.getRatingsCategory(starRating);

    return (
        <div className="StarRatingWithCategory">
            <StarRating stars={starRating} />
            <span>
                {category} ({FormatUtils.numWithCommas(numberOfReviews)})
            </span>
        </div>
    );
};

StarRatingWithCategory.propTypes = {
    numberOfReviews: PropTypes.number,
    starRating: PropTypes.number,
};

StarRatingWithCategory.defaultProps = {
    numberOfReviews: 0,
    starRating: 0,
};

export default StarRatingWithCategory;
